import {fromJS, Map} from 'immutable';
import {combineReducers} from 'redux-immutable';

import paginatorReducer from '../../paginator/reducer';
import treeReducer from '../tree/reducer';
import Students from './component';
import mainReducer from './reducer';


export const initialState = {};

const _reducer = combineReducers({
    main: mainReducer,
    paginator: paginatorReducer,
    regionsTreeFilter: treeReducer,
    citiesTreeFilter: treeReducer,
    schoolsTreeFilter: treeReducer,
    gradesTreeFilter: treeReducer,
    hasExamTreeFilter: treeReducer,
    hasBookTreeFilter: treeReducer,
    selected: q => q || new Map(),

    regionsTree: treeReducer,
    citiesTree: treeReducer,
    schoolsTree: treeReducer,
    gradesTree: treeReducer,
    clientTree:treeReducer,
    hasExamTreeFilter: treeReducer,
    hasBookTreeFilter: treeReducer,
});
export const reducer = (state, action) => {
    if (!state.get('paginator')) {
        const id = state.get('elementId') || window.uuidv4();
        state = fromJS({
            main: {elementId: id},
        });
    }
    state = _reducer(state, action);
    state = state.set('selected', state.get('paginator').get('selected'));
    return state;
};

export const component = Students;
